import React from "react";
import {
  ModalOverlay,
  ModalContainer,
  ModalContent,
  ModalIcon,
  ModalTitle,
  ModalMessage,
  ModalButton,
} from "./Modal.styled";

const Modal = ({ type, title, message, onClose }) => {
  const getIcon = () => {
    switch (type) {
      case "success":
        return "✓";
      case "error":
        return "!";
      default:
        return "i";
    }
  };

  const getButtonText = () => {
    switch (type) {
      case "success":
        return "Continue";
      case "error":
        return "Try Again";
      default:
        return "OK";
    }
  };

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContainer onClick={(e) => e.stopPropagation()}>
        <ModalContent>
          <ModalIcon type={type}>{getIcon()}</ModalIcon>
          <ModalTitle>{title}</ModalTitle>
          <ModalMessage>{message.replace(/^Error: /, "")}</ModalMessage>
          <ModalButton type={type} onClick={onClose}>
            {getButtonText()}
          </ModalButton>
        </ModalContent>
      </ModalContainer>
    </ModalOverlay>
  );
};

export default Modal;
